import React from 'react'
import { Field } from 'redux-form'
import renderSelect from '../fields/renderSelect'
import renderTextarea from '../fields/renderTextarea'
import RenderDateRangePicker from '../fields/renderDateRangePicker'
import i18n from '../../translations/i18n';

let Coaching = props => {
	let lng = props.lng;
	let locale = (lng==="fr" ? "fr" : "en-gb")
	let coachingLanguages = [i18n.t('coaching.french', {lng}), i18n.t('coaching.english', {lng}),
		i18n.t('coaching.german', {lng}), i18n.t('coaching.spanish', {lng})]
	return (
			<div>
				<div className="form-section">
					<div className="subtitle title title-border title-border text-left">
						<h6>{i18n.t('coaching.title', {lng})}</h6>
					</div>
					<div className="row">
						<div className="col-12 form-input">
							<Field
								name="coachingPackage"
								component={renderSelect}
								label={i18n.t('coaching.number_of_hours', {lng})}
								options={props.number_of_hours}
								placeholder={i18n.t('app.please_select', {lng})}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-12 form-input">
							<Field
								name="coachingLanguage"
								component={renderSelect}
								label={i18n.t('coaching.language', {lng})}
								options={coachingLanguages}
								placeholder={i18n.t('app.please_select', {lng})}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-12 form-input">
							<Field
								name="myAvailabilities"
								component={renderTextarea}
								label={i18n.t('coaching.myavailabilities', {lng})}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-12 form-input">
							<RenderDateRangePicker 
								startLabel={i18n.t('coaching.desired_start_date', {lng})}
								endLabel={i18n.t('coaching.desired_end_date', {lng})}
								localeLang={locale}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-6 form-input">
							<Field
								name="coachingLevel"
								component={renderSelect}
								label={i18n.t('coaching.level', {lng})}
								options={props.levels}
								placeholder={i18n.t('app.please_select', {lng})}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-12 form-input">
							<Field
								name="coachingGoals"
								component={renderTextarea}
								label={i18n.t('coaching.goals', {lng})}
							/>
						</div>
					</div>
				</div>
			</div>
	)
}


export default Coaching


// WEBPACK FOOTER //
// ./src/components/coaching/coaching.js